export class XYPointsConverter {
    constructor(window) {
        this.window = window;
    }
    GetDataX(screenX) {
        if (this.window.XScale === 0) {
            return 0;
        }
        return this.window.FminFloatX + (screenX - this.window.ClientRectangle.X) / this.window.XScale;
    }
    GetDataY(screenY) {
        if (this.window.YScale === 0) {
            return 0;
        }
        return (this.window.ClientRectangle.Bottom() - screenY) / this.window.YScale + this.window.FminFloatY;
    }
    GetScreenX(dataX) {
        return this.window.ClientRectangle.X + (dataX - this.window.FminFloatX) * this.window.XScale;
    }
    GetScreenY(dataY) {
        return this.window.ClientRectangle.Bottom() - (dataY - this.window.FminFloatY) * this.window.YScale;
    }
    GetDataIndexByX(screenX) {
        return -1;
    }
    GetBarIndex(timeX) {
        return -1;
    }
    GetScreenXbyTime(timeX) {
        return -1;
    }
}
